import React from "react";
import Footer from "../../components/Footer/Footer";
import Hero from "../../components/Hero/Hero";
import { useNavigate, useParams } from "react-router-dom";
import data from "./data";
import newData from "../../data/index";
import { useEffect } from "react";
import ProductContent from "../../components/ProductContent/ProductContent";

const ServiceDetailsPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  let selectedData = data.filter((item) => item.slug === slug)[0];
  useEffect(() => {
    if (!selectedData) {
      navigate("/");
    }
  }, []);

  return (
    <div className="bg_light" style={{ overflowX: "hidden" }}>
      {selectedData ? (
        <>
          <Hero
            {...data.filter((item) => item.slug === slug)[0].data}
            colored
            slug={slug}
          />
          {newData.filter((item) => item.slug === slug).length > 0 ? (
            <ProductContent
              data={newData.filter((item) => item.slug === slug)[0].data}
            />
          ) : (
            <></>
          )}

          <Footer />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ServiceDetailsPage;
